// Temporary hardcoded link (per product: dynamic URLs come ~Sept 2026 once the
// docs move to GitHub/Archbee and can read the desktop version JSON). We point
// at the support article — which covers macOS, Windows, and Linux install —
// rather than hardcoding raw DMG/EXE URLs that break on every release.
// Swap this one value when the download experience is finalized.
export const DESKTOP_DOWNLOAD_URL =
  'https://support.optimizely.com/hc/en-us/articles/48356461062925-Optimizely-Opal-Desktop-app';
